import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=45da23b2&scoped=true&"
import script from "./CreateForm.vue?vue&type=script&lang=js&"
export * from "./CreateForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=45da23b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da23b2",
  null
  
)

export default component.exports